import { Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextareaAutosize, TextField, Typography, useTheme } from "@mui/material";
import { font } from "../../../styles/font";
import { forwardRef } from "react";
import { TableVirtuoso } from "react-virtuoso";
import { blue, green, grey, red, yellow } from "@mui/material/colors";
import { useState } from "react";
import ReactQuill from "react-quill";
import { Editor_ModuleConfig } from "../../../constant/ApplicationVariables";
import CustomEditor from "../../common/CustomEditor";
import { EditOutlined, FiberManualRecord } from "@mui/icons-material";
import { convertEditorDataToReact } from "../../../utils/StringOperations";
import DashboardListItemsDialog from "../../dialog/DashboardListItemsDialog";
import { LightTooltip } from "../../styled/CustomComponent";


const TableComponents = {
    Scroller: forwardRef((props, ref) => <TableContainer component={Paper} style={{ overflowX: "auto", overflowY: "scroll" }} {...props} ref={ref} />),
    Table: (props) => <Table {...props} style={{ borderCollapse: 'separate' }} />,
    TableHead: TableHead,
    TableRow: (props) => <TableRow {...props} />,
    TableBody: forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
    TableCell: (props) => <TableCell {...props} sx={{ ...props?.sx, px: "1rem !important" }} />,
}

let statusColor = {
    "needs attention": yellow[400],
    "on track": green[400],
    "at risk": red[400],

    "completed": green[400],
    "in progress": blue[400],
    "not started": grey[400],

    "open": blue[400],
    "resolved": green[400],
    "closed": grey[400],


}



export default function ProjectOverView() {
    const theme = useTheme();

    const [isEditProjectSummary, setIsEditProjectSummary] = useState(false);
    const [isOpenListItemsDialog, setIsOpenListItemsDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [projectSummary, setProjectSummary] = useState("Project Summary: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio.");


    const [dashboardData, setDashboardData] = useState({
        projectSummary: `This week, we have completed the following tasks: - Completed the project initiation document - Completed the project deployment document - Started the project training document - Completed the project training document - Started the project support document - Completed the project support document - Started the project maintenance document - Completed the project maintenance document - Started the project upgrade document - Completed the project upgrade document - Started the project maintenance document - Completed the project maintenance document`,
        projectStatus: [
            {
                category: "Schedule",
                status: "On Track",
                comments: "This project is running smoothly and all the tasks are on track."
            },
            {
                category: "Scope",
                status: "Needs Attention",
                comments: "This project needs more work in terms of scope. There are some tasks that are not completed yet."
            },
            {
                category: "Budget",
                status: "On Track",
                comments: "This project is running within the budget. There are no issues with the budget."
            },

            {
                category: "Risks / Issues",
                status: "At Risk",
                comments: "This project is running smoothly, but there are some risks that need to be addressed."
            },
            {
                category: "Resource",
                status: "On Track",
                comments: "This project is running smoothly and all the resources are being utilized effectively."
            },
            {
                category: "Quality",
                status: "On Track",
                comments: "This project is running smoothly and the quality of the deliverables is good."
            },

        ],
        nextWeekActivities: [
            "Finalize the project deployment document",
            "Finalize the project training document",
            "Finalize the project support document",
            "Finalize the project maintenance document",
            "Finalize the project upgrade document",
            "Finalize the project maintenance document",
        ],
        topRisksIssues: [
            {
                id: "1",
                description: "Lack of resources",
                impact: "HIGH",
                mitigationAction: "Hire more resources",
                owner: "Project Manager",
                status: "Open"
            },
            {
                id: "2",
                description: "Change in scope",
                impact: "LOW",
                mitigationAction: "Re-evaluate scope and adjust project plan",
                owner: "Project Manager",
                status: "RESOLVED"
            },
        ],
        decisionApprovalNeeded: [
            {
                topic: "Budget Approval",
                decisionRequiredBy: "John Doe",
                owner: "Finance Team",
                notes: "Approval needed for the revised budget proposal."
            },
            {
                topic: "Resource Allocation",
                decisionRequiredBy: "Jane Smith",
                owner: "HR Department",
                notes: "Decision required on allocation of additional resources for the upcoming phase."
            },
        ],
        otherNotes: ["Meeting with the stake holders", "Planning for the next sprint", "Testing of the new features", "Fixing the reported bugs", "Create a new test case", "Create a new use case", "Create a new user story", "Create a new project"],
        keyMilestones: [
            {
                mileStoneDelivery: "Project Initiation",
                plannedDate: "2023-08-01",
                actualForcastDate: "2023-08-01",
                status: "Completed",
                comments: "The project was initiated and all the necessary documents were prepared."
            },
            {
                mileStoneDelivery: "Requirements Gathering",
                plannedDate: "2023-08-01",
                actualForcastDate: "2023-08-15",
                status: "Completed",
                comments: "All the requirements were gathered and documented."
            },
            {
                mileStoneDelivery: "Design",
                plannedDate: "2023-08-15",
                actualForcastDate: "2023-09-01",
                status: "Completed",
                comments: "The design of the project was completed."
            },
            {
                mileStoneDelivery: "Development",
                plannedDate: "2023-09-01",
                actualForcastDate: "2023-12-01",
                status: "In Progress",
                comments: "The development of the project is in progress."
            },
            {
                mileStoneDelivery: "Testing",
                plannedDate: "2023-12-01",
                actualForcastDate: "2024-01-01",
                status: "Not Started",
                comments: "The testing of the project is planned to start soon."
            },
            {
                mileStoneDelivery: "Deployment",
                plannedDate: "2024-01-01",
                actualForcastDate: "2024-01-15",
                status: "Not Started",
                comments: "The deployment of the project is planned to start soon."
            },
        ],
        teamResourceUpdate: [
            "New resource 'John Smith' has been added to the project.",
            "Resource 'Jane Doe' has been removed from the project.",
            "Resource 'Bob Johnson' has been updated with new skills: Java, Python, React.",
        ],

    });

    const [currentListItemData, setCurrentListItemData] = useState(null);

    const handleOpenListItemsDialog = (keyName) => {

        setCurrentListItemData({
            key: keyName,
            value: dashboardData[keyName]
        });

        setIsOpenListItemsDialog(true);
    }

    const handleCloseListItemsDialog = () => {
        setIsOpenListItemsDialog(false);
    }

    return (
        <Box className="flex gap-4 w-full h-full">


            {/* left container */}
            <Box className=" flex flex-col gap-4 w-[60%] h-fit">


                {/* project summary / next week activity */}
                <Box className="h-[54vh] flex flex-col gap-4   ">

                    <Card
                        headingChildren={
                            <Box className="flex items-center justify-between w-full">
                                <CustomHeading >Project Summary</CustomHeading>
                                <IconButton onClick={() => setIsEditProjectSummary(!isEditProjectSummary)} >
                                    <EditOutlined />
                                </IconButton>
                            </Box>
                        }
                    >
                        <Box className="flex flex-col w-full max-h-[120px] overflow-y-auto" >
                            {isEditProjectSummary ?
                                <CustomEditor
                                    value={dashboardData?.projectSummary}
                                    handleUpdateValue={(val) => setDashboardData({ ...dashboardData, projectSummary: val })}
                                    placeholderMessage="Project summary"
                                    containerFixedHeight={"120px"}
                                    editorHeight={"69px"}
                                />
                                :
                                <CustomTypography >
                                    {convertEditorDataToReact(dashboardData?.projectSummary)}
                                </CustomTypography>
                            }
                        </Box>
                    </Card>


                    <Card
                        headingChildren={
                            <Box className="flex items-center justify-between w-full">
                                <CustomHeading >Key Activities for Next Week</CustomHeading>
                                <IconButton onClick={() => handleOpenListItemsDialog("nextWeekActivities")} >
                                    <EditOutlined />
                                </IconButton>
                            </Box>
                        }
                    >
                        <CustomTypography >
                            <Box className="flex flex-col gap-1">
                                {dashboardData.nextWeekActivities?.map((item, index) => (
                                    <Box key={index} className="flex items-center gap-2">
                                        <Box className="flex w-1 h-1 rounded-full " bgcolor={theme.palette.text.primary}></Box>
                                        <CustomTypography color="textSecondary">{item}</CustomTypography>
                                    </Box>
                                ))}

                            </Box>
                        </CustomTypography>
                    </Card>


                </Box>


                {/* top risks and issues / decision and approval needed / other notes highlights */}
                <Box className="h-[56vh] flex  gap-4 ">

                    {/*  top risks and issues / decision and approval needed */}
                    <Box className="flex flex-col gap-4  w-[60%]">
                        <Box className="flex-1 flex flex-col gap-4">
                            <Card
                                headingChildren={
                                    <CustomHeading >Top risks and issues</CustomHeading>
                                }
                            >

                                <Box className="flex-1 flex flex-col gap-2">
                                    <Box className="flex-1 flex items-center justify-between gap-4 ">
                                        <RisksIssuesTable list={dashboardData?.topRisksIssues} />
                                    </Box>

                                    <Box className="flex items-center justify-around gap-4 ">
                                        {["Open", "Resolved", "Closed"]?.map((item, index) => (
                                            <StatusLabel key={index} status={item} />
                                        ))}
                                    </Box>
                                </Box>
                            </Card>
                        </Box>


                        <Box className="flex-1 flex flex-col gap-4 ">
                            <Card
                                headingChildren={
                                    <CustomHeading >Decision and approval needed</CustomHeading>
                                }
                            >

                                <Box className="flex-1 flex flex-col gap-2">
                                    <Box className="flex-1 flex items-center justify-between gap-4 ">
                                        <DecisionApprovalTable list={dashboardData?.decisionApprovalNeeded} />
                                    </Box>

                                    {/* <Box className="flex items-center justify-around gap-4 ">
                                        {["Open", "Resolved", "Closed"]?.map((item, index) => (
                                            <StatusLabel key={index} status={item} />
                                        ))}
                                    </Box> */}
                                </Box>
                            </Card>
                        </Box>
                    </Box>


                    {/* other notes highlights */}
                    <Box className="flex-1 flex flex-col gap-4  ">
                        <Card
                            headingChildren={
                                <Box className="flex items-center justify-between w-full">
                                    <CustomHeading >Other notes</CustomHeading>

                                    <IconButton onClick={() => handleOpenListItemsDialog("otherNotes")} >
                                        <EditOutlined />
                                    </IconButton>
                                </Box>
                            }
                        >

                            <Box className="flex flex-col gap-1">
                                {dashboardData?.otherNotes?.map((item, index) => (
                                    <Box key={index} className="flex items-center gap-2">
                                        <Box className="flex w-1 h-1 rounded-full " bgcolor={theme.palette.text.primary}></Box>
                                        <CustomTypography color="textSecondary">{item}</CustomTypography>
                                    </Box>
                                ))}

                            </Box>

                        </Card>
                    </Box>

                </Box>


            </Box>

            {/* right container */}
            <Box className="flex-1 flex flex-col gap-4 h-fit">

                {/* overall project status */}
                <Box className="h-[38vh] flex flex-col gap-4 ">
                    <Card
                        headingChildren={
                            <CustomHeading >Overall Project Status</CustomHeading>
                        }
                    >
                        <Box className="flex-1 flex flex-col gap-2">
                            <Box className="flex-1 flex items-center justify-between gap-4 ">
                                <ProjectStatusTable list={dashboardData?.projectStatus} />
                            </Box>

                            <Box className="flex items-center justify-around gap-4 ">
                                {["On Track", "Needs Attention", "At Risk"]?.map((item, index) => (
                                    <StatusLabel key={index} status={item} />

                                ))}
                            </Box>
                        </Box>
                    </Card>
                </Box>


                {/* key milestone / team and resource update */}
                <Box className="h-[56vh] flex flex-col gap-4 ">

                    <Box className="flex-1 flex flex-col gap-4 ">
                        <Card
                            headingChildren={
                                <CustomHeading >Key milestone and deliveries</CustomHeading>
                            }
                        >
                            <Box className="flex-1 flex flex-col gap-2">
                                <Box className="flex-1 flex items-center justify-between gap-4 ">
                                    <MilestoreDeliveryTable list={dashboardData?.keyMilestones} />
                                </Box>

                                <Box className="flex items-center justify-around gap-4 ">
                                    {["Completed", "In Progress", "Not Started"]?.map((item, index) => (
                                        <StatusLabel key={index} status={item} />

                                    ))}
                                </Box>
                            </Box>
                        </Card>
                    </Box>

                    <Box className="flex-1 flex flex-col gap-4 ">
                        <Card
                            headingChildren={
                                <Box className="flex items-center justify-between w-full">
                                    <CustomHeading >Teams and resource update</CustomHeading>


                                    <IconButton onClick={() => handleOpenListItemsDialog("teamResourceUpdate")} >
                                        <EditOutlined />
                                    </IconButton>
                                </Box>
                            }
                        >

                            <Box className="flex flex-col gap-1">
                                {dashboardData?.teamResourceUpdate?.map((item, index) => (
                                    <Box key={index} className="flex items-center gap-2">
                                        <Box className="flex w-1 h-1 rounded-full " bgcolor={theme.palette.text.primary}></Box>
                                        <CustomTypography color="textSecondary">{item}</CustomTypography>
                                    </Box>
                                ))}

                            </Box>
                        </Card>
                    </Box>
                </Box>
            </Box>




            <DashboardListItemsDialog
                open={isOpenListItemsDialog}
                handleClose={handleCloseListItemsDialog}
                handleConfirm={(list) => { }}
                loading={isLoading}
                list={currentListItemData}
            />
        </Box>
    )
}



function Card({ headingChildren, children }) {
    const theme = useTheme();

    return (
        <Box className="flex-1 flex flex-col  " bgcolor={theme.palette.background.paper} borderRadius={theme.shape.borderRadius} border={`1px solid ${theme.palette.divider}`} >
            <Box className="flex border-b px-4 py-2">
                {headingChildren}
            </Box>

            <Box className="flex-1 flex px-4 py-2 ">
                {children}
            </Box>
        </Box>
    )
}

function CustomTypography(props) {
    return (
        <Typography fontSize={font.size.fs_5} color={props.color || "textSecondary"} className="whitespace-pre-wrap" {...props}>{props.children}</Typography>
    )
}

function CustomHeading(props) {
    return (
        <Typography fontSize={font.size.fs_5} color={props.color || "textSecondary"} fontWeight={600} className="whitespace-pre-wrap" {...props}>{props.children}</Typography>
    )
}


function StatusLabel({ status }) {
    return (
        <Box className="flex items-center gap-0">
            <FiberManualRecord sx={{ color: statusColor[status.toLowerCase()] }} />
            <CustomTypography color="textSecondary">{status}</CustomTypography>
        </Box>
    )
}

export function ProjectStatusTable({ list, ...props }) {
    const theme = useTheme();


    return (
        <TableVirtuoso
            style={{ width: "100%", minHeight: "100%", overflowX: 'auto', }}
            data={list}
            components={TableComponents}
            fixedHeaderContent={() => (
                <TableHead>

                    <TableCell align="center" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"   > Category </CustomHeading>
                    </TableCell>

                    <TableCell align="center" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Status (RAG) </CustomHeading>
                    </TableCell>

                    <TableCell align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", width: "100%", maxWidth: "100%", background: theme.palette.header.main, }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Comments </CustomHeading>
                    </TableCell>
                </TableHead>
            )}


            itemContent={(index, itemData) => (

                <TableRow sx={{ "&:hover": { background: grey[100], }, display: "table-row" }}>

                    <TableCell padding="none" align="center" sx={{ minWidth: "100px", maxWidth: "100px", borderRight: `1px solid ${grey[300]}` }} >

                        <CustomTypography className="truncate px-2 py-1"> {itemData?.category} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="center" sx={{ minWidth: "100px", maxWidth: "100px", borderRight: `1px solid ${grey[300]}` }} >

                        <LightTooltip title={<CustomTypography className="truncate px-2 py-1"> {itemData?.status} </CustomTypography>}>
                            <FiberManualRecord sx={{ color: statusColor[itemData?.status?.toLowerCase()] }} />
                        </LightTooltip>

                    </TableCell>

                    <TableCell padding="none" align="left" sx={{ width: "100%", maxWidth: "100%", }} >
                        <CustomTypography className="truncate px-2 py-1"> {itemData?.comments} </CustomTypography>
                    </TableCell>

                </TableRow>

            )}
        />
    )
}

export function MilestoreDeliveryTable({ list, ...props }) {
    const theme = useTheme();


    return (
        <TableVirtuoso
            style={{ width: "100%", minHeight: "100%", overflowX: 'auto', }}
            data={list}
            components={TableComponents}
            fixedHeaderContent={() => (
                <TableHead>

                    <TableCell align="center" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "130px", maxWidth: "130px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Milestone / Delivery </CustomHeading>
                    </TableCell>

                    <TableCell align="center" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Planned Date </CustomHeading>
                    </TableCell>

                    <TableCell align="center" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "110px", maxWidth: "110px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Actual / Forcast </CustomHeading>
                    </TableCell>

                    <TableCell align="center" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Status </CustomHeading>
                    </TableCell>

                    <TableCell align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", width: "100%", maxWidth: "100%", background: theme.palette.header.main, }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Comments </CustomHeading>
                    </TableCell>
                </TableHead>
            )}


            itemContent={(index, itemData) => (

                <TableRow sx={{ "&:hover": { background: grey[100], }, display: "table-row" }}>

                    <TableCell padding="none" align="center" sx={{ minWidth: "130px", maxWidth: "130px", borderRight: `1px solid ${grey[300]}` }} >
                        <CustomTypography className="truncate px-2 py-1"> {itemData?.mileStoneDelivery} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="center" sx={{ minWidth: "100px", maxWidth: "100px", borderRight: `1px solid ${grey[300]}` }} >
                        <CustomTypography className="truncate px-2 py-1"> {itemData?.plannedDate} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="center" sx={{ minWidth: "110px", maxWidth: "110px", borderRight: `1px solid ${grey[300]}` }} >
                        <CustomTypography className="truncate px-2 py-1"> {itemData?.actualForcastDate} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="center" sx={{ minWidth: "100px", maxWidth: "100px", borderRight: `1px solid ${grey[300]}` }} >

                        <LightTooltip title={<CustomTypography className="truncate px-2 py-1"> {itemData?.status} </CustomTypography>}>
                            <FiberManualRecord sx={{ color: statusColor[itemData?.status?.toLowerCase()] }} />
                        </LightTooltip>
                    </TableCell>

                    <TableCell padding="none" align="left" sx={{ width: "100%", maxWidth: "100%", }} >
                        <CustomTypography className="truncate px-2 py-1"> {itemData?.comments} </CustomTypography>
                    </TableCell>


                </TableRow>

            )}
        />
    )
}

export function RisksIssuesTable({ list, ...props }) {
    const theme = useTheme();

    return (
        <TableVirtuoso
            style={{ width: "100%", minHeight: "100%", overflowX: 'auto', }}
            data={list}
            components={TableComponents}
            fixedHeaderContent={() => (
                <TableHead>

                    <TableCell align="center" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "40px", maxWidth: "40px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > ID </CustomHeading>
                    </TableCell>

                    <TableCell align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Description </CustomHeading>
                    </TableCell>

                    <TableCell align="center" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Impact </CustomHeading>
                    </TableCell>

                    <TableCell align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "120px", maxWidth: "120px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Mitigation / Action </CustomHeading>
                    </TableCell>

                    <TableCell align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Owner </CustomHeading>
                    </TableCell>

                    <TableCell align="center" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Status </CustomHeading>
                    </TableCell>
                </TableHead>
            )}


            itemContent={(index, itemData) => (

                <TableRow sx={{ "&:hover": { background: grey[100], }, display: "table-row" }}>

                    <TableCell padding="none" align="center" sx={{ minWidth: "42px", maxWidth: "42px", borderRight: `1px solid ${grey[300]}` }} >

                        <CustomTypography className="truncate px-2 py-1"> {itemData?.id} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="left" sx={{ minWidth: "100px", maxWidth: "100px", borderRight: `1px solid ${grey[300]}` }} >

                        <CustomTypography className="truncate px-2 py-1"> {itemData?.description} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="center" sx={{ minWidth: "100px", maxWidth: "100px", borderRight: `1px solid ${grey[300]}` }} >
                        <CustomTypography className="truncate px-2 py-1"> {itemData?.impact} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="left" sx={{ minWidth: "120px", maxWidth: "120px", borderRight: `1px solid ${grey[300]}` }} >
                        <CustomTypography className="truncate px-2 py-1"> {itemData?.mitigationAction} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="left" sx={{ minWidth: "100px", maxWidth: "100px", borderRight: `1px solid ${grey[300]}` }} >
                        <CustomTypography className="truncate px-2 py-1"> {itemData?.owner} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="center" sx={{ minWidth: "100px", maxWidth: "100px", }} >
                        <LightTooltip title={<CustomTypography className="truncate px-2 py-1"> {itemData?.status} </CustomTypography>}>
                            <FiberManualRecord sx={{ color: statusColor[itemData?.status?.toLowerCase()] }} />
                        </LightTooltip>
                    </TableCell>

                </TableRow>

            )}
        />
    )
}

export function DecisionApprovalTable({ list, ...props }) {
    const theme = useTheme();

    return (
        <TableVirtuoso
            style={{ width: "100%", minHeight: "100%", overflowX: 'auto', }}
            data={list}
            components={TableComponents}
            fixedHeaderContent={() => (
                <TableHead>


                    <TableCell align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Topic </CustomHeading>
                    </TableCell>

                    <TableCell align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "150px", maxWidth: "150px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Decision Required By </CustomHeading>
                    </TableCell>

                    <TableCell align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Owner </CustomHeading>
                    </TableCell>

                    <TableCell align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                        <CustomHeading className="whitespace-nowrap py-1 px-2"  > Notes </CustomHeading>
                    </TableCell>

                </TableHead>
            )}


            itemContent={(index, itemData) => (

                <TableRow sx={{ "&:hover": { background: grey[100], }, display: "table-row" }}>



                    <TableCell padding="none" align="left" sx={{ minWidth: "100px", maxWidth: "100px", borderRight: `1px solid ${grey[300]}` }} >

                        <CustomTypography className="truncate px-2 py-1"> {itemData?.topic} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="left" sx={{ minWidth: "150px", maxWidth: "150px", borderRight: `1px solid ${grey[300]}` }} >
                        <CustomTypography className="truncate px-2 py-1"> {itemData?.decisionRequiredBy} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="left" sx={{ minWidth: "100px", maxWidth: "100px", borderRight: `1px solid ${grey[300]}` }} >
                        <CustomTypography className="truncate px-2 py-1"> {itemData?.owner} </CustomTypography>
                    </TableCell>

                    <TableCell padding="none" align="left" sx={{ minWidth: "100px", maxWidth: "100px", }} >
                        <CustomTypography className="truncate px-2 py-1"> {itemData?.notes} </CustomTypography>
                    </TableCell>


                </TableRow>

            )}
        />
    )
}
